module.exports = __webpack_public_path__ + "static/media/DESKTOP-ASTOUND-BANNER.237233b0.webp";